import { BarChart3Icon, GlobeIcon, MagnetIcon, SettingsIcon, WrenchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Industrial Automation Fundamentals',
    summary: 'Introduction, automation types, components, control principles, electrical basics, PLC fundamentals, logic, Industry 4.0.',
    icon: WrenchIcon,
  },
  {
    number: '2',
    title: 'PLC Systems & Architecture',
    summary: 'PLC hardware, CPU, memory, I/O modules, scan cycle, power systems, expansion, controller selection.',
    icon: SettingsIcon,
  },
  {
    number: '3',
    title: 'PLC Logic & Control Principles',
    summary: 'Programming fundamentals, Ladder Logic, Boolean operations, timers, sequences, motor control, programming languages.',
    icon: MagnetIcon,
  },
  {
    number: '4',
    title: 'Sensors, Actuators & Industrial I/O',
    summary: 'Sensor technologies, measurement devices, industrial actuators, motors, drives, signal processing, field device integration.',
    icon: BarChart3Icon,
  },
  {
    number: '5',
    title: 'HMI, SCADA & Industrial Communication',
    summary: 'Operator interfaces, SCADA systems, industrial data, networks, protocols, PLC integration, security, Industry 4.0.',
    icon: GlobeIcon,
  },
  {
    number: '6',
    title: 'PLC Troubleshooting, Maintenance & Advanced Automation',
    summary: 'Fault analysis, system troubleshooting, maintenance strategies, reliability, safety, advanced technologies.',
    icon: WrenchIcon,
  },
];
